x<template>
  <div class="col-md-3 col-6 infos-card text-center">
    <div v-if="duration != null && errorState == false" class="">
      <i :class="icon"></i>
      <span class="text-muted">{{ label }}</span>
      <div>{{ duration }}</div>
      <span
        class="text-muted font-12"
        v-if="cost != null && cost.trim() !== ''"
        >{{ cost }}</span
      >
      <span
        class="text-muted font-12"
        v-else-if="cost != null && cost.trim() == ''"
        >{{ cost }}</span
      >
    </div>

    <div v-if="duration == null && errorState == false" class="">
      <b-skeleton
        class="mx-auto"
        style="border-radius: 50%"
        height="30px"
        width="30px"
      ></b-skeleton>
      <b-skeleton class="mx-auto" height="20px" width="100%"></b-skeleton>
      <b-skeleton class="mx-auto" height="20px" width="80%"></b-skeleton>
    </div>
    <div
      v-if="duration == null && errorState == true"
      class="d-flex align-items-center justify-content-center"
    >
      <div>
        <div class="error-box text-center">
          <div
            class="
              error-icon
              d-flex
              align-items-center
              justify-content-center
              text-center
              mx-auto
            "
          >
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="exclamation-triangle"
              class="svg-inline--fa fa-exclamation-triangle fa-w-18"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
            >
              <path
                fill="currentColor"
                d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
              ></path>
            </svg>
          </div>
          <div class="mt-3">
            <span class="text-muted text-center">Erreur. Réessayer</span>
          </div>
        </div>
        <div class="mt-1 d-flex justify-content-center">
          <button
            @click="reloadRequest()"
            v-b-tooltip.hover
            title="Réessayer"
            class="btn btn-outline-secondary"
          >
            <i class="mdi mdi-reload"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["duration", "icon", "label", "cost", "errorState"],
  components: {},
  name: "InfosCard",
  data: function () {
    return {};
  },
  mounted: async function () {},
  methods: {
    reloadRequest() {
      this.$emit("reload");
    },
  },
  watch: {
    duration() {},
  },
};
</script>
<style scoped lang="css">
.error-box .error-icon {
  background: #fff2bf;
  color: #000;
  border-radius: 50%;
  height: 40px;
  width: 40px;
}
.error-box .error-icon svg {
  height: 20px !important;
  width: 20px !important;
}
.error-box .text-muted {
  font-weight: 400 !important;
  line-height: 100% !important;
}
::v-deep .btn-outline-secondary {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
}
::v-deep .btn-outline-secondary i {
  background: none !important;
}
</style>
